
import * as React from 'react';
import { DataGrid, gridPageCountSelector, gridPageSelector, useGridSelector, useGridApiRef } from '@mui/x-data-grid';
import { Box, Button, Container, Typography, Pagination, PaginationItem, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import campimg from '../../assets/marketing.png'
import ReusableDialog from '../CommanComponents/ReusableDialog';


function CustomPagination({ apiRef, isMobile }) {
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  const handleChange = (event, value) => {
    const newPage = value - 1;
    const currentPage = apiRef.current?.getState?.().pagination?.page;
    if (currentPage === newPage) return; // avoid no-op updates that can loop
    apiRef.current.setPage(newPage);
    if (isMobile && apiRef.current) {
      setTimeout(() => {
        apiRef.current.autosizeColumns({ includeHeaders: true });
      }, 0);
    }
  };
  return (
   <Pagination  color="primary" variant="outlined" shape="rounded" page={page + 1} count={pageCount} 
     renderItem={(props2) => <PaginationItem {...props2} disableRipple />} onChange={handleChange}  />
     );
   }

   const PAGE_SIZE = 5;

export default function CampaignList() {
  const navigate = useNavigate();
  const apiRef = useGridApiRef();
  const isMobile = useMediaQuery('(max-width:768px)');
  const [paginationModel, setPaginationModel] = useState({ pageSize: PAGE_SIZE, page: 0,}); 
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  useEffect(() => {
    if (isMobile && apiRef.current) {
      apiRef.current.autosizeColumns({ includeHeaders: true });
    }
  }, [isMobile]);


 const columns = [
  { field: 'id', headerName: 'Sr no.', flex: isMobile ? undefined : 0.5},
  { field: 'ctitle', headerName: 'Coupon Title',  flex: isMobile ? undefined : 1,},
  { field: "offimg", headerName: "Offer Img", flex: isMobile ? undefined : 1,
    renderCell: (params) => {  if (!params.value || params.value === "NA") {
      return <Typography variant="body2">No Image</Typography>; } return ( <img src={params.value} alt="offer"
        style={{ width: 50, height: 50, objectFit: "cover", borderRadius: 4 }} /> ); }, },
  { field: 'cvalue', headerName: 'Coupon Value', flex: isMobile ? undefined : 1 },
  { field: 'activedate', headerName: 'Active Date', flex: isMobile ? undefined : 1 },
  { field: 'expdate', headerName: 'Expiry Date', flex: isMobile ? undefined : 1 },
  { field: 'shortd', headerName: 'Short Description', flex: isMobile ? undefined : 1 },
  { field: 'longd', headerName: 'Long Description', flex: 2, },
 ]
const rows = [
  {id:'1',ctitle:'Coupon123', cvalue: '122', activedate:'888', expdate:'8899', shortd:'778', longd:'88'}
]

  return (
    <Container>
      
      <Box sx={{ display: 'flex', justifyContent: 'start', mb: 2 }}>
        <Button  variant="contained" sx={{ backgroundColor: '#000000', color: '#ffffff' }}  onClick={() => navigate(-1)} >
          Back </Button>
       </Box>

      {/* Title */}
      <Typography  variant="h6" gutterBottom
        sx={{ background: 'linear-gradient(195deg, #49a3f1, #1A73E8)', p: 1, color: '#ffffff',
          borderRadius: '4px', mb: 3, display: 'flex', alignItems: 'center' }} > Campaign List
      </Typography>

       <Box sx={{ display: 'flex', justifyContent: 'end', mb: 2 }}>
         <Button variant="contained" sx={{ background:'linear-gradient(195deg, #49a3f1, #1A73E8)',
          color: '#ffffff'}} onClick={() => setOpen(true)}  >
          <img src={campimg} alt="campaign" style={{height:'25px', width:'auto', marginRight:'5px'}} /> New Campaign
         </Button>
       </Box>
     

      {/* DataGrid */}
      <Box sx={{ height: 'auto', maxHeight: 500, width: '100%' }}>
        <DataGrid  apiRef={apiRef} rows={rows} columns={columns} initialState={{ pagination: { paginationModel } }}
          paginationModel={paginationModel} onPaginationModelChange={setPaginationModel} pageSizeOptions={[PAGE_SIZE]} 
          slots={{ pagination: () => <CustomPagination apiRef={apiRef} isMobile={isMobile} />,}}
          sx={{
             '& .MuiDataGrid-cell': {
               whiteSpace: 'normal',   
               lineHeight:'20px',
               wordBreak: 'break-word', 
               display: 'flex',
              alignItems: 'center', // Vertically center content
              gap: '4px'},
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#f0f0f0',
              color: '#000',
              fontWeight: 'bold',
            },
            '& .MuiDataGrid-columnHeaderTitle': {
              fontSize: 14,
              fontWeight: '600',
               whiteSpace: 'normal',
              wordBreak: 'break-word'
            },
          }}
          showToolbar
        />
      </Box>

       <ReusableDialog open={open} onClose={handleClose} />
    </Container>
  );
}
